import { url } from "../../../url";
import { loaded } from "../actions";

const fetchTodos = async (dispatch) => {
    const response = await fetch(url);
    const todos = await response.json();

    dispatch(loaded(todos));
};

export default fetchTodos;